/**
 * MohMayaa — global smooth / inertia scroll
 * Buttery, eased mouse-wheel scrolling used site-wide (desktop only —
 * touch devices already have native momentum scroll and are skipped).
 * Respects prefers-reduced-motion. Leaves native scroll alone inside
 * open dialogs/drawers (cart, search, quick-add) so those keep normal
 * behaviour.
 */
(function () {
  if (window.__mmSmoothScrollInit) return;
  window.__mmSmoothScrollInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('ontouchstart' in window && navigator.maxTouchPoints > 0) return;

  var current = window.scrollY || window.pageYOffset;
  var target = current;
  var ease = 0.09;
  var raf = null;

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function loop() {
    current += (target - current) * ease;
    if (Math.abs(target - current) < 0.4) {
      current = target;
      window.scrollTo(0, current);
      raf = null;
      return;
    }
    window.scrollTo(0, current);
    raf = window.requestAnimationFrame(loop);
  }

  window.addEventListener(
    'wheel',
    function (e) {
      if (
        e.target.closest &&
        e.target.closest('dialog, [open], [data-cart-drawer], .cart-drawer, [data-mm-no-smooth]')
      ) {
        return;
      }
      e.preventDefault();
      target = Math.min(maxScroll(), Math.max(0, target + e.deltaY));
      if (!raf) raf = window.requestAnimationFrame(loop);
    },
    { passive: false }
  );

  var syncTimer = null;
  window.addEventListener(
    'scroll',
    function () {
      if (raf) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        current = window.scrollY || window.pageYOffset;
        target = current;
      }, 80);
    },
    { passive: true }
  );
})();